module.exports = __webpack_public_path__ + "img/2_04.66a0d1ce.jpg";